import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Server, Network, Cpu, Globe, Wrench, Radio, Bot, Code, Check } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  server: Server,
  network: Network,
  cpu: Cpu,
  globe: Globe,
  wrench: Wrench,
  radio: Radio,
  bot: Bot,
  code: Code
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Our IT Services
          </h2>
          <p className="text-xl text-gray-600">
            Comprehensive technology solutions tailored to your business needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <Card 
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-500 border-2 hover:border-emerald-500/50 bg-white hover:-translate-y-2 card-hover animate-slide-in-bottom"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <CardHeader>
                  <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-cyan-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-emerald-500/30 animate-pulse-glow">
                    <Icon className="w-8 h-8 text-white animate-float" />
                  </div>
                  <CardTitle className="text-2xl text-gray-900 group-hover:text-emerald-600 transition-colors">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-base text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center gap-3 text-gray-700">
                        <Check className="w-5 h-5 text-emerald-500 flex-shrink-0" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-600 mb-4 text-lg">
            Need a custom solution? We're here to help.
          </p>
          <button 
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="text-emerald-600 hover:text-emerald-700 font-semibold text-lg underline underline-offset-4 transition-colors"
          >
            Talk to Our Experts →
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
